import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { Box, SxProps } from '@mui/system';
import { IBudget } from 'common/entities';
import { sumWithCurrency } from 'core/services/currency.service';
import { useMemo } from 'react';

export interface AccumulationProgressProps {
  accumulation: IBudget;
}

interface AccumulationMonthEntry {
  month: string;
  amount: number;
  accumulated: number;
  commited: boolean;
}

const createRows = (accumulation: IBudget): AccumulationMonthEntry[] => {
  const { periods } = accumulation;
  const rows: AccumulationMonthEntry[] = [];
  let accumulated = 0;
  periods.forEach((period, index) => {
    const selectedMonth = new Date(period.year, period.month);
    const periodAccumulation = period.budget ?? 0;
    accumulated += periodAccumulation;
    rows.push({
      month: selectedMonth.toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric'
      }),
      amount: periodAccumulation,
      accumulated,
      commited: true
    });
  });
  return rows;
};

const tableCellSx: SxProps = {};

const sxDisabledCell: SxProps = {
  ...tableCellSx,
  color: '#999'
};

const AccumulationProgress = ({ accumulation }: AccumulationProgressProps) => {
  const monthEntries = useMemo(() => createRows(accumulation), [accumulation]);

  return (
    <TableContainer component={Box}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={tableCellSx}>Month</TableCell>
            <TableCell sx={tableCellSx} align="right">
              Month Accumulation
            </TableCell>
            <TableCell sx={tableCellSx} align="right">
              Accumulated Total
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {accumulation.accumulationStartAmount && (
            <TableRow hover>
              <TableCell sx={tableCellSx}>Initial</TableCell>
              <TableCell sx={sxDisabledCell} align="right">
                -
              </TableCell>
              <TableCell sx={tableCellSx} align="right">
                {sumWithCurrency(accumulation.accumulationStartAmount)}
              </TableCell>
            </TableRow>
          )}
          {monthEntries.map((entry, index) => (
            <TableRow key={index} hover>
              <TableCell sx={entry.amount ? tableCellSx : sxDisabledCell}>
                {entry.month}
              </TableCell>
              <TableCell
                sx={entry.amount ? tableCellSx : sxDisabledCell}
                align="right"
              >
                {sumWithCurrency(entry.amount)}
              </TableCell>
              <TableCell
                sx={entry.amount ? tableCellSx : sxDisabledCell}
                align="right"
              >
                {sumWithCurrency(entry.accumulated)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AccumulationProgress;
